export default __webpack_public_path__ + "static/iq-a277b7541565cd8cf49f988b55ef4f22.svg";